import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

export const CardContainer = styled(motion.div)(({ theme }) => ({
  flexBasis: 0,
  flexGrow: 1,
  backgroundColor: '#FFFFFF',
  height: '6.25rem',
  minWidth: '17.5rem',
  maxWidth: '37.5rem',

  [theme.breakpoints.up('md')]: {
    minWidth: '20rem',
  },

  borderRadius: '1rem',
  padding: '0.75rem',
  boxShadow: '0px 2px 0.625rem 0px rgba(0,0,0,0.05)',
  cursor: 'default',
}));

export const InnerLayout = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  height: '100%',
});

export const IconWrapper = styled(Box)({
  padding: '0.5rem',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '& svg': {
    width: '2rem',
    height: '2rem',
    display: 'block',
  },
});

export const TextWrapper = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '0.125rem',
});

export const Title = styled(Typography)({
  fontFamily: '"Rookery new", sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  letterSpacing: '0.00625rem',
  color: '#161c27',
  fontWeight: 500,
  margin: 0,
});

export const Description = styled(Typography)({
  fontFamily: '"Rookery new", sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1rem',
  color: '#5f5e60',
  margin: 0,
});
